import * as Yup from "yup";
import { getInitialValues } from "layouts/views/common/common";

const formField = {
  customerCode: {
    type: "text", //required
    name: "customerCode", //required
    label: "Customer Code", //required
    errorMsg: "Customer Code is required.", //optional
    maxLength: 20, //optional
    tabIndex: 1,
    required: true,
    disabled: true,
  },
  warehouseCode: {
    type: "text",
    name: "warehouseCode",
    label: "Warehouse Code",
    required: true,
    errorMsg: "Warehouse Code is required.",
    disabled: true,
  },
  manifestNumber: {
    type: "text",
    name: "manifestNumber",
    label: "Manifest No",
    maxLength: 20,
    disabled: true,
  },
  noOfDroppoint: {
    type: "number",
    name: "noOfDroppoint",
    label: "No. of Drop Point",
    disabled:true
  },
  carrier: {
    type: "select",
    name: "carrier",
    label: "Carrier",
    required: true,
    errorMsg: "Carrier is required.",
  },
  loadingDatetime: {
    type: "date",
    name: "loadingDatetime",
    label: "Loading Datetime",
    required: true,
    errorMsg: "Loading Datetime is required.",
  },
  truckNo: {
    type: "text",
    name: "truckNo",
    label: "Truck No",
    maxLength: 20,
    required: true,
    errorMsg: "Truck No is required.",
  },
  transportArrangement: {
    type: "select",
    name: "transportArrangement",
    label: "Transport Arrangement",
    required: true,
    errorMsg: "Transport Arrangement is required.",
  },
  descriptions1: {
    type: "text",
    name: "descriptions1",
    label: "Descriptions 1",
    maxLength: 200,
  },
  truckType: {
    type: "select",
    name: "truckType",
    label: "Truck Type",
  },
  manPowerRate: {
    type: "select",
    name: "manPowerRate",
    label: "Man Power Rate",
  },
  manPowerQty: {
    type: "number",
    name: "manPowerQty",
    label: "Man Power Qty",
  },
  status: {
    type: "text",
    name: "status",
    label: "Status",
    disabled: true,
  },
  pushToEtrax: {
    name: "pushToEtrax",
    label: "Push To Etrax",
    type: "switch",
    default: false,
    required: true,
  },
};

const {
  customerCode,
  manifestNumber,
  noOfDroppoint,
  carrier,
  loadingDatetime,
  truckNo,
  transportArrangement,
  descriptions1,
  truckType,
  manPowerRate,
  manPowerQty,
  status,
  pushToEtrax,
} = formField;

export const headerRender = [
  [manifestNumber, noOfDroppoint, customerCode, status],
  [carrier, truckNo, loadingDatetime, transportArrangement],
  [manPowerRate, manPowerQty, descriptions1, truckType],
  [pushToEtrax],
];

export const headerValues = getInitialValues(formField);

export const headerValidation = Yup.object().shape({
  [customerCode.name]: Yup.string().nullable().required(customerCode.errorMsg),
  [noOfDroppoint.name]: Yup.number().min(0),
  [carrier.name]: Yup.string().nullable().required(carrier.errorMsg),
  [loadingDatetime.name]: Yup.string().nullable().required(loadingDatetime.errorMsg),
  [truckNo.name]: Yup.string().nullable().max(truckNo.maxLength).required(truckNo.errorMsg),
  [transportArrangement.name]: Yup.string().nullable().required(transportArrangement.errorMsg),
  [descriptions1.name]: Yup.string().nullable().max(descriptions1.maxLength),
  [truckType.name]: Yup.string().nullable(),
  [manPowerRate.name]: Yup.string().nullable(),
  [manPowerQty.name]: Yup.number().min(0),
  [pushToEtrax.name]: Yup.boolean(),
});
